/* global femcare, Swiper */

femcare.gallery.retailers = {

    init () {
        if ($('.product-retailers').length) {
            this.initSliders();
        }
        if ($('.product-main').length) {
            this.initAnalytics();
        }
    },

    initSliders () {
        const $retailers = $('.product-retailers');

        if ($retailers.length) {

            const options = {
                lazy: true,
                breakpoints: {
                    350: {
                        slidesPerView: 3.5
                    },
                    500: {
                        slidesPerView: 4
                    },
                    600: {
                        slidesPerView: 5
                    },
                    1200: {
                        slidesPerView: 6
                    }

                },
                navigation: {
                    nextEl: '.product-retailers__next',
                    prevEl: '.product-retailers__previous'
                },
            };

            $retailers.each(() => {
                const instanceOptions = JSON.parse(JSON.stringify(options));
                new Swiper('.product-retailers__slider', instanceOptions);
            });
        }
    },

    initAnalytics () {
        /** Retailers for click to buy integration (FR market)*/
        $('.product-buy .product-buy__actions a, .product-buy .product-buy__actions button').on('click', (e) => {
            const retailerEventId = $(e.target).parents('.product-buy')[0].dataset.gaEventId;
            const retailer_ga4_data = this.getRetailerGaData(retailerEventId, true)

            femcare.tracking.analytics.pushEvent('ga4_buy_now_list_retailers', retailer_ga4_data);
        });

        /** Retailers for retailers listed on the page*/
        $('.product-retailers__slide').on('click', (e) => {
            const retailerEventId = $(e.target).parents('.product-retailers__slide')[0].dataset.gaEventId;
            const retailer_ga4_data = this.getRetailerGaData(retailerEventId, false);

            femcare.tracking.analytics.pushEvent('ga4_buy_now_go_to_retailer', retailer_ga4_data);
        });
    },

    getRetailerGaData(eventId, isRetailersList){
        const productObject = femcare.shared.util.getEntryFromObject(window.gaDataLayer, 'Id', eventId);
        const retailerName = productObject[0].Data.retailer;
        const productId = productObject[0].Data.single_item_id;
        const productName = productObject[0].Data.single_item_name;
        let retailer_ga4_data = {};

        if( isRetailersList ) {
            retailer_ga4_data = {
                single_item_id: productId,
                single_item_name: productName
            }
        } else {
            retailer_ga4_data = {
                retailer: retailerName,
                single_item_id: productId,
                single_item_name: productName
            }
        }

        return retailer_ga4_data;
    }
};
